/* eslint-disable indent */
import GeolocationProvider from './providers/GeolocationProvider';
import OneTrustGeolocationProvider from './providers/OneTrustGeolocationProvider';

/**
 * Represents GeolocationProvidersFactory
 */
class GeolocationProvidersFactory {
	/**
	 * Creates CMS provider
	 * @param {String} providerName Provider name
	 * @returns {CMSProvider}
	 */
	create(providerName) {
		switch (providerName) {
			case 'OneTrust':
				return new OneTrustGeolocationProvider();
			default:
				return new GeolocationProvider();
		}
	}
}

export default new GeolocationProvidersFactory();
